/**
 * sanitizeSearchQuery
 * ---------------------------------------------------------------------------
 * Normalise a free-text company-search query so every call-site sends a
 * consistent, special-character-free string to the backend.
 *
 * Rules:
 *   • Keep ASCII letters (A–Z / a–z), digits (0–9), and whitespace
 *   • Drop every other character (parentheses, punctuation, ampersands,
 *     hyphens, dots, quotes, slashes, unicode symbols, etc.)
 *   • Collapse runs of whitespace to a single space
 *   • Trim leading / trailing whitespace
 *
 * Examples:
 *   "Safari Industries (India) Limited" → "Safari Industries India Limited"
 *   "M&M — Mahindra"                    → "MM Mahindra"
 *   "AT&T, Inc."                        → "ATT Inc"
 *   "  Bajaj   Electricals  "           → "Bajaj Electricals"
 */
export function sanitizeSearchQuery(raw: string | null | undefined): string {
  if (!raw) return '';
  return raw
    .replace(/[^A-Za-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
